import { Api } from "./api"

const PATH = 'category' 
const ENDPOINTS = {
    Liste:'liste',
    Store:'store',
    Show:'show',
    Update:'update',
    Delete:'delete',
}

const getCategories = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Liste}`, signal)
}

const getCategory = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Show}/${id}`, signal)
}

const storeCategory = (payload,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Store}`,payload, signal)
}

const updateCategory = (id,payload,signal) => {
    return Api.update(`${PATH}/${ENDPOINTS.Update}/${id}`,payload, signal)
}

const deleteCategory = (id,signal) => {
    return Api.erase(`${PATH}/${ENDPOINTS.Delete}/${id}`, signal)
}

export const categoryApi={
    getCategories,
    getCategory,
    storeCategory,
    updateCategory,
    deleteCategory,
}